export default __webpack_public_path__ + "static/media/caravan_icon.71439ada.svg";